<template>
  <div v-if="isVimeo" class="video-wrapper">
    <iframe
      :src="'https://player.vimeo.com/video/' + videoId"
      frameborder="0"
      :width="width"
      :height="height"
      title="Video"
      allowfullscreen
    ></iframe>
  </div>
  <div v-else-if="isYoutube" class="video-wrapper">
    <iframe
      :src="youtubeVideoUrl"
      frameborder="0"
      :width="width"
      :height="height"
      title="Video"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  computed: {
    isVimeo() {
      return this.url.indexOf('vimeo') !== -1;
    },
    isYoutube() {
      return this.url.indexOf('youtube') !== -1 || this.isYoutuDotBe;
    },
    isYoutuDotBe() {
      return this.url.indexOf('youtu.be') !== -1;
    },
    videoId() {
      if (this.isVimeo) {
        return this.url.substring(this.url.lastIndexOf('/') + 1);
      } else if (this.isYoutuDotBe) {
        return this.url.substring(this.url.lastIndexOf('.be/') + 4);
      } else if (this.isYoutube) {
        return this.url.substring(this.url.lastIndexOf('?v=') + 3);
      }
      return null;
    },
    youtubeVideoUrl() {
      return (
        'https://www.youtube.com/embed/' +
        this.videoId +
        '?origin=' +
        window.location.origin
      );
    }
  }
};
</script>

<style>
.video-wrapper {
  margin-top: 15px;
}
</style>
